<script lang="ts">
    import { VpInformationIcon } from '@decathlon-experience/icons/svelte';
    import { writable } from 'svelte/store';

    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import Drawer from '$saga/components/Drawer.svelte';
    import { formatCurrency } from '$saga/utils/price';
    import type { VisibleDate } from '$saga/views/Tour/VisibleDates/types';

    export let ageRangePrices: VisibleDate['ageRangePrices'];
    export let disabled: boolean = false;

    const isModalOpen = writable(false);
</script>

<Drawer
    titleLabel={trans('tour.dates.age_range_prices.other_prices')}
    {disabled}
    isOpen={isModalOpen}
>
    <slot name="triggerlink" slot="triggerlink">
        <div
            class={cn(
                'flex gap-2xs border-l border-solid border-border-quiet p-s text-sm underline',
                !disabled && 'hover:no-underline',
            )}
        >
            {trans('tour.dates.age_range_prices.other_prices')}
            <VpInformationIcon class="size-l" />
        </div>
    </slot>

    <div class="mb-[15vh] mt-m flex flex-col gap-m px-l desktop:px-3xl">
        {#each ageRangePrices as { id, name, price } (id)}
            <div
                class="flex w-full flex-col justify-between gap-xs border-t border-solid border-border-quiet py-xs"
            >
                <span class="font-semibold">{name}</span>
                <span
                    >{formatCurrency(price.amount / 100)}
                    {trans('tour.dates.age_range_prices.per_traveler')}</span
                >
            </div>
        {/each}
    </div>
</Drawer>
